export const profileFormInputsValidation = (answers: any) => {
    let hasRequiredFieldsFilled = true;
    if (
        !answers.hasOwnProperty("GraduationYear") ||
        answers["GraduationYear"] === undefined ||
        answers["GraduationYear"] === ""
    ) {
        hasRequiredFieldsFilled = false;
    }
    if (
        !answers.hasOwnProperty("SchoolName") ||
        answers["SchoolName"] === undefined || answers["SchoolName"] === ""
    ) {
        hasRequiredFieldsFilled = false;
    }
    if (
        !answers.hasOwnProperty("ContactPreferenceList") ||
        (Array.isArray(answers["ContactPreferenceList"]) &&
            answers["ContactPreferenceList"].length === 0)
    ) {
        hasRequiredFieldsFilled = false;
    }
    if (!answers.hasOwnProperty("HasTimeAccommodation")) {
        hasRequiredFieldsFilled = false;
    }
    if (
        answers.hasOwnProperty("HasTimeAccommodation") &&
        answers["HasTimeAccommodation"] === true &&
        !answers.hasOwnProperty("TimeAccommodation")
    ) {
        hasRequiredFieldsFilled = false;
    }
    if (
        answers.hasOwnProperty("HasTimeAccommodation") &&
        answers["HasTimeAccommodation"] === true &&
        answers["TimeAccommodation"] === "Other" &&
        (
            answers["OtherTimeAccommodation"] === undefined ||
            answers["OtherTimeAccommodation"] === "" ||
            answers["OtherTimeAccommodation"] === null
        )
    ) {
        hasRequiredFieldsFilled = false;
    }
    if (!answers.hasOwnProperty("HasOtherOfficialAccommodation")) {
        hasRequiredFieldsFilled = false;
    }
    if (answers["HasOtherOfficialAccommodation"] === true) {
        if (
            !answers.hasOwnProperty("OtherOfficialAccommodation") ||
            answers["OtherOfficialAccommodation"] === undefined ||
            answers["OtherOfficialAccommodation"] === "" ||
            answers["OtherOfficialAccommodation"] === null
        ) {
            hasRequiredFieldsFilled = false;
        }
    }
    return hasRequiredFieldsFilled;
};